<!-- @file 修改密码 -->
<template>
  <div class="p-update-psw">
    <plv-form
      ref="form"
      :model="form"
      :rules="rules"
      content-inner-width="340px"
      label-width="120px"
    >
      <plv-form-item label="原密码" prop="oldPasswd">
        <plv-input
          v-model="form.oldPasswd"
          type="password"
          placeholder="请输入原密码"
        />
      </plv-form-item>

      <plv-form-item label="新密码" prop="newPasswd">
        <plv-input
          v-model="form.newPasswd"
          type="password"
          placeholder="请输入新密码"
        />
      </plv-form-item>

      <plv-form-item label="确认新密码" prop="confirmPasswd">
        <plv-input
          v-model="form.confirmPasswd"
          type="password"
          placeholder="再次输入新密码"
        />
      </plv-form-item>

      <plv-form-item>
        <plv-button @click="handleSubmit">保存</plv-button>
      </plv-form-item>
    </plv-form>
  </div>
</template>

<script>
import { defaultFormRules } from '@/utils/type';
export default {
  data() {
    return {
      form: {
        oldPasswd: '',
        newPasswd: '',
        confirmPasswd: ''
      },
      rules: Object.assign({
        newPasswd: {
          validator: (rule, value, callback) => {
            if (value === this.form.oldPasswd) {
              callback(new Error('新密码不能与原密码相同'));
            }
            callback();
          }
        },
        confirmPasswd: {
          validator: (rule, value, callback) => {
            if (value !== this.form.newPasswd) {
              callback(new Error('两次密码输入不一致'));
            }
            callback();
          }
        }
      }, defaultFormRules)
    };
  },

  methods: {
    // 处理保存
    async handleSubmit() {
      try {
        this.$emit('loading');
        await this.$refs.form.validate();
        await this.$store.dispatch('user/updatePassword', this.form);
        this.$toast.success('保存成功');
        this.form = {
          oldPasswd: '',
          newPasswd: '',
          confirmPasswd: ''
        };
      } catch {} finally {
        this.$emit('cancelLoading');
      }
    }
  },
};
</script>
